import { Component, OnInit, Input } from '@angular/core';
import { ShippingMethod } from '@pages/checkout-app/types';
import { isNumber } from '@utils/number-utils';
@Component({
  selector: 'display-rate-prices',
  styles: [
    '.col { display:flex; flex-direction: column;}',
    '.gap { gap: 6px; padding: 0 2px; }',
    '.font12 { font-size: 12px;}',
  ],
  template: `
    @if (LiveRateMethodCategories.includes(shipping?.shippingMethod?.category)) {
      <div>
        <div class="font12">
          <div>{{ rates[0].rate }}</div>
          @if (rates[0].percentOfShippingCharge) {
            <div>
              shipping charge:
              <div class="col">{{ rates[0].percentOfShippingCharge }}</div>
            </div>
          }
          @if (rates[0].flatAmount) {
            <div>
              flat:
              <div class="col">{{ rates[0].flatAmount }}</div>
            </div>
          }
        </div>
      </div>
    } @else {
      @switch (rates?.length) {
        @case (1) {
          <div class="font12">
            <div>Rate: {{ rates[0].rate }}</div>
            <div>
              Cart value:
              <div class="col">{{ rates[0].minCartValue }} - {{ rates[0].maxCartValue }}</div>
            </div>
          </div>
        }
        @default {
          <div>
            <pdq-button [plain]="true" (onClick)="displayRatePrices = !displayRatePrices">{{
              displayRatePrices ? 'Hide rates' : 'Show rates'
            }}</pdq-button>
            @if (displayRatePrices) {
              <div class="col gap">
                @for (rate of rates; track rate) {
                  <div class="font12">
                    <div>Rate: {{ rate.rate }}</div>
                    <div>
                      Cart value:
                      <div class="col">{{ rate.minCartValue }} - {{ rate.maxCartValue }}</div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      }
    }
  `,
  standalone: false,
})
export class RatePricesComponent implements OnInit {
  @Input() shipping;
  @Input() currency;

  readonly LiveRateMethodCategories = [ShippingMethod.DOMESTIC_LIVE_RATE, ShippingMethod.INTERNATIONAL_LIVE_RATE];

  rates = [];
  displayRatePrices: boolean = false;
  constructor() {}

  ngOnInit() {
    const { minOrderPriceRange, maxOrderPriceRange, rate, additionalPriceRanges, percentageOfCarrierCost, flatAmount } =
      this.shipping;
    let ratePrices = [];
    if (
      this.shipping.shippingMethod?.category === ShippingMethod.DOMESTIC_LIVE_RATE ||
      this.shipping.shippingMethod?.category === ShippingMethod.INTERNATIONAL_LIVE_RATE
    ) {
      const liveRatePrice: any = {
        rate: 'Live rate',
      };
      if (percentageOfCarrierCost > 0) {
        liveRatePrice.percentOfShippingCharge = percentageOfCarrierCost + '%';
      }
      if (isNumber(flatAmount)) {
        liveRatePrice.flatAmount = this.currency + flatAmount;
      }

      this.rates = [liveRatePrice];
    } else {
      ratePrices = [{ rate, minOrderPriceRange, maxOrderPriceRange }];
      if (additionalPriceRanges?.length) {
        ratePrices = ratePrices.concat(additionalPriceRanges);
      }
      this.rates = ratePrices.map((r) => {
        const maxCartValue =
          !r.maxOrderPriceRange || +r.maxOrderPriceRange == 0 ? 'No limit' : this.currency + r.maxOrderPriceRange;
        const minCartValue = this.currency + (!r.minOrderPriceRange ? 0 : r.minOrderPriceRange);
        return {
          rate: this.currency + r.rate,
          minCartValue,
          maxCartValue,
        };
      });
    }
  }
}
